/*
 * File: d:\projects\AutoFiFront\src\Cookies\CookieWrapper.ts
 * Project: d:\projects\AutoFiFront
 * Created Date: Wednesday February 22nd 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Wednesday February 22nd 2023 1:40:39 pm
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 * HISTORY:
 */

import CookieInstance from "Cookies/Cookie";

/**
 * Factory to create cookie instance Object
 * @param {Object} target The instance of cookie
 */
const CookieFactory = (target: CookieInstance) => ({
  setCookie: (field: string, data: any) => target.setCookie(field, data),
  getCookie: (field: string) => target.getCookie(field),
  removeCookie: (field: string) => target.removeCookie(field),
});

const cookie = CookieFactory(new CookieInstance());

export default cookie;
